import { action, computed, makeObservable, onBecomeObserved } from "mobx"

import { countriesApi } from "@src/shared/api"
import Collection from "@src/shared/classes/Collection/Collection"
import { loading } from "@src/shared/classes/utils/loading"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

export type Country = {
  alpha_2: string
  alpha_3: string
  name: string
}

export class CountryCollection extends loading(["fetch"], Collection<Country>) {
  constructor() {
    super()

    makeObservable(this, {
      countriesOptions: computed,
      fetch: action.bound,
    })

    onBecomeObserved(this, "isLoading", this.fetch)
  }

  async fetch() {
    const {
      data: { data },
    } = await countriesApi.getCountries()

    if (data) {
      this.replace(data as Country[])
    }
  }

  get countriesOptions() {
    return this.items.map((country) => ({
      id: crypto.randomUUID(),
      label: country.name,
      value: country.alpha_3,
    }))
  }
}

export const GlobalCountryCollection = wrapSingleton(CountryCollection)
